import * as React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';

const ToggleShowDetails = (props) =>{
    const {id,toggle} = props;

    const onHandleClick = (e) => {
        e.preventDefault();
        props.onToggleClick(id);
    }

    return(
        <div className=" col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div id={'showDtls'+id} className="box" onClick={onHandleClick}>
            {toggle? 
                <span className="k-space-right" style={{fontSize: "11px"}}>
                    Hide Details 
                    &nbsp;<span className="k-icon k-i-arrow-chevron-up" />
                </span> :
                <span className="k-space-right" style={{fontSize: "11px"}}>
                    Show Details  
                    &nbsp;<span className="k-icon k-i-arrow-chevron-down" />
                </span> }    
            </div>
        </div>
    )
}

export default ToggleShowDetails;